import draggable from 'vuedraggable';
import Card from '@/components/TaskCard/TaskCard.vue'
import AddTaskCard from '@/components/AddTaskCard/AddTaskCard.vue'
import { get_token } from "@/router";
import axios from "axios";
import Swal from 'sweetalert2';
import { nextTick } from 'vue';
/* global bootstrap */

const PRIORITY_TONES = [
  { keywords: ['urgent', 'high'], tone: 'high' },
  { keywords: ['important'], tone: 'important' },
  { keywords: ['medium'], tone: 'medium' },
  { keywords: ['low'], tone: 'low' },
];

const priority_label = (priority) => (
  String(priority?.priority_name || priority?.name || priority?.label || '').toLowerCase()
);

export default {
  name: 'Column',
  components: {
    draggable,
    Card,
    AddTaskCard
  },
  props: {
    bucket: {
      type: Array,
      required: true
    },
    members: {
      type: Array
    },

    buckets: {
      type: Array,
      required: true
    },

    isNew: {
      type: Boolean,
      default: false
    },
    statuses: {
      type: Array,
      required: true
    },
    priorities: {
      type: Array,
      required: true
    },
    filters: {
      type: Object,
      default: () => ({})
    },
    can_manage_task_statuses: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update-title', 'add-task', 'delete-bucket', 'statuses-updated', 'priorities-updated'],
  data() {
    return ({
      isEditing: false,
      localTitle: this.bucket?.name || '',
      isAddingTask: false,
      selected_column_id: '',
      selected_task: null,
      local_start_date: '',      // Don't access this.selected_task here
      local_due_date: '',
      description: '',
      task_id: null,
      comments: [],
      local_task_status_id: '',
      local_priority_status_id: '',
      task_attachments: [],
      editingTaskName: false,
      task_name: '',
      loading_column_page: false,
      scrollTimeout: null,
      show_modal_assign_dropdown: false,
      modal_assign_search_query: '',
      adding_task_status_field: '',
      new_task_status_name: '',
      creating_task_status: false,
      task_status_add_error: '',
      task_status_search_status: '',
      task_status_search_priority: '',
      selected_task_status_label_status: '',
      selected_task_status_label_priority: ''
    });
  },
  mounted() {
    // Load first page if not already loaded
    if (!this.bucket.tasks?.length) {
      this.loadNextPage(this.bucket.id, 1);
    }

    if (this.$refs.taskModal) {
      this.$refs.taskModal.addEventListener("shown.bs.modal", async () => {

        // Safely get priority id
        this.local_priority_status_id = this.selected_task?.priority?.id
          ? Number(this.selected_task.priority.id)
          : '';

        // Safely get progress id
        this.local_task_status_id = this.selected_task?.progress?.id
          ? Number(this.selected_task.progress.id)
          : '';
      });
    }

    document.addEventListener('click', this.handle_modal_assign_click_outside);

  },
  beforeUnmount() {
    document.removeEventListener('click', this.handle_modal_assign_click_outside);
  },

  watch: {
    selected_task(newTask) {
      if (newTask) this.task_name = newTask.name;
    },
    editingTaskName(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const task_input_event = this.$refs.taskInput;
          if (task_input_event) {
            task_input_event.style.height = 'auto';
            task_input_event.style.height = task_input_event.scrollHeight + 'px';
            task_input_event.focus();
          }
        });
      }
    }
  },
  computed: {
    tasks: {
      get() {
        return this.bucket?.tasks || [];
      },
      set(newTasks) {
        // Emit event to notify parent of changes OR
        // If you can safely modify bucket.tasks, do:
        this.$emit('update:tasks', newTasks); // if using v-model:tasks from parent
        // or
        this.bucket.tasks = newTasks; // only if safe (not recommended)
      }
    },
    checklist_with_placeholder() {
      const checklist = this.selected_task?.checklist_items || [];

      if (
        checklist.length === 0 ||
        (checklist[checklist.length - 1] &&
          checklist[checklist.length - 1].text.trim() !== '')
      ) {
        return [...checklist, { id: null, text: '', is_completed: false }];
      }
      return checklist;
    },
    selected_priority() {
      return this.priorities.find((priority) => (
        Number(priority.id) === Number(this.local_priority_status_id)
      ));
    },
    modal_normalized_assign_query() {
      return String(this.modal_assign_search_query || '').toLowerCase().trim();
    },
    modal_filtered_assignees() {
      const assignees = Array.isArray(this.selected_task?.assignees) ? this.selected_task.assignees : [];
      const query = this.modal_normalized_assign_query;
      if (!query) return assignees;

      return assignees.filter((assignee) => {
        const fullName = String(
          assignee?.portal_access?.base_profile_details?.creater?.full_name || ''
        ).toLowerCase();
        const email = String(
          assignee?.portal_access?.base_profile_details?.creater?.email || ''
        ).toLowerCase();
        return fullName.includes(query) || email.includes(query);
      });
    },
    modal_filtered_suggestions() {
      const members = Array.isArray(this.members) ? this.members : [];
      const assignees = Array.isArray(this.selected_task?.assignees) ? this.selected_task.assignees : [];

      const assignedUserIds = new Set(
        assignees
          .map((a) => a?.portal_access?.base_profile_details?.creater?.id)
          .filter(Boolean)
      );

      const query = this.modal_normalized_assign_query;

      return members.filter((member) => {
        const userId = member?.user?.id;
        if (userId && assignedUserIds.has(userId)) return false;

        if (!query) return true;

        const fullName = String(member?.full_name || '').toLowerCase();
        const email = String(member?.user?.email || member?.email || '').toLowerCase();
        return fullName.includes(query) || email.includes(query);
      });
    }
  },
  methods: {
    format_label(text) {
      return String(text || "")
        .trim()
        .split(/[\s_-]+/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join(" ");
    },
    priority_tone(priority) {
      const label = priority_label(priority);
      const match = PRIORITY_TONES.find(({ keywords }) =>
        keywords.some((keyword) => label.includes(keyword))
      );

      return match?.tone || 'default';
    },
    clear_start_date() {
      this.clear_task_date('start_date');
    },
    clear_due_date() {
      this.clear_task_date('due_date');
    },
    async clear_task_date(field) {
      if (!this.selected_task?.id) return;
      const payload = {
        task_id: this.selected_task.id,
        field
      }

      const headersConfig = {
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
      };

      try {
        await axios.post(
          `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/clear_task_due_date/`,
          payload,
          headersConfig
        );

        if (field === 'start_date') {
          this.local_start_date = null;
          this.selected_task.start_date = null;
        }
        if (field === 'due_date') {
          this.local_due_date = null;
          this.selected_task.due_date = null;
        }

      } catch (error) {

        console.error(`Failed to clear ${field}`, error)

      }

    },
    handleScroll() {
      if (this.scrollTimeout) clearTimeout(this.scrollTimeout);

      this.scrollTimeout = setTimeout(() => {
        const container = this.$refs.columnRef;
        const pagination = this.bucket.tasks_pagination;

        if (!container || !pagination) return;

        const scrollBottom = container.scrollTop + container.clientHeight;
        const threshold = container.scrollHeight - 100;

        if (
          scrollBottom >= threshold &&
          !this.loadingNextPage &&
          pagination.current_page < pagination.total_pages
        ) {
          this.loadNextPage(this.bucket.id, pagination.current_page + 1);
        }
      }, 150);
    },

    auto_grow(event) {
      const el = event.target;
      el.style.height = 'auto'; // reset
      el.style.height = el.scrollHeight + 'px'; // expand to fit content
    },
    column_task_filter_payload() {
      const filters = this.filters || {};
      const payload = {
        search: filters.search || "",
        assignee_ids: filters.users || [],
        statuses: filters.statuses || [],
        due_after: filters.dateFrom || "",
        due_before: filters.dateTo || ""
      };
      return payload;
    },
    async fetch_column_tasks_page(columnId, page, pageSize) {
      const payload = {
        column_id: columnId,
        page,
        page_size: pageSize,
        ...this.column_task_filter_payload()
      };
      const config = {
        headers: { Authorization: `Token ${this.getToken()}` }
      };
      const response = await axios.post(
        `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_column_tasks/`,
        payload,
        config
      );

      const tasks = response.data.results.tasks || response.data.tasks || [];
      const count = response.data.count || tasks.length;
      const next = response.data.next;
      const previous = response.data.previous;
      return ({ tasks, count, next, previous });
    },
    column_page_size() {
      const taskHeight = 120; // px per task card
      const headerHeight = 100; // px for header/nav
      return Math.floor((window.innerHeight - headerHeight) / taskHeight) || 5;
    },
    page_number_from_pagination_link(link) {
      if (!link) return null;
      if (!Number.isNaN(Number(link))) return Number(link);

      try {
        const url = new URL(link, window.location.origin);
        const page = Number(url.searchParams.get("page"));
        return Number.isNaN(page) ? null : page;
      } catch (error) {
        return null;
      }
    },
    async loadNextPage(columnId, page = null, targetBucket = this.bucket) {
      if (this.loadingNextPage) return;
      this.loadingNextPage = true;

      try {
        const column = targetBucket;
        const pagination = column.tasks_pagination || {};
        const nextPage = page || this.page_number_from_pagination_link(pagination.next) || ((pagination.current_page || 0) + 1);
        const pageSize = this.column_page_size();

        if (pagination.total_pages && nextPage > pagination.total_pages) return;
        if (!page && pagination.next === null && pagination.current_page >= pagination.total_pages) return;

        const pageData = await this.fetch_column_tasks_page(columnId, nextPage, pageSize);

        const existingTaskIds = new Set((column.tasks || []).map(task => task.id));
        const newTasks = pageData.tasks.filter(task => !existingTaskIds.has(task.id));
        column.tasks = [...(column.tasks || []), ...newTasks];

        column.tasks_pagination = {
          current_page: nextPage,
          total_pages: pagination.total_pages || Math.ceil(pageData.count / pageSize),
          total_tasks: pageData.count,
          next: pageData.next,
          previous: pageData.previous
        };
      } catch (err) {
        console.error("Error fetching tasks:", err);
      } finally {
        this.loadingNextPage = false;
      }
    },
    async reload_column_tasks(targetBucket = this.bucket) {
      if (!targetBucket?.id || this.loadingNextPage) return;

      const loadedTaskCount = Math.max(targetBucket.tasks?.length || 0, 5);
      const pageSize = this.column_page_size();
      const refreshedTasks = [];
      let currentPage = 1;
      let totalPages = 1;
      let latestPageData = null;

      do {
        latestPageData = await this.fetch_column_tasks_page(targetBucket.id, currentPage, pageSize);
        refreshedTasks.push(...latestPageData.tasks);
        totalPages = Math.ceil(latestPageData.count / pageSize) || 1;
        currentPage += 1;
      } while (refreshedTasks.length < loadedTaskCount && currentPage <= totalPages);

      if (latestPageData) {
        targetBucket.tasks = refreshedTasks;
        targetBucket.tasks_pagination = {
          current_page: currentPage - 1,
          total_pages: totalPages,
          total_tasks: latestPageData.count,
          next: latestPageData.next,
          previous: latestPageData.previous
        };
      }
    },

    getToken() {
      return get_token();
    },
    get_user_id() {
      return localStorage.getItem('user_id') || '';
    },
    enableEditing() {
      this.isEditing = true;
      this.$nextTick(() => this.$refs.titleInput?.focus());
    },
    handleTitleSubmit() {
      if (!this.localTitle.trim()) {
        this.isEditing = false;
        return;
      }

      if (this.isNew) {
        this.add_new_column();
      } else {
        this.edit_column();
      }

      this.isEditing = false;
    },
    edit_column() {
      this.isEditing = false;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_column/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({ column_id: this.bucket.id, name: this.localTitle }),
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.$emit('column-renamed', response.data)
          }

        },

        complete: () => {
          this.isLoading = false;
        }
      });
    },
    startAddingTask(columnId) {

      if (this.isAddingTask && this.selected_column_id === columnId) {
        // If already adding for this column, toggle off
        this.isAddingTask = false;
        this.selected_column_id = null;
      } else {
        // Otherwise, show the form for this column
        this.isAddingTask = true;
        this.selected_column_id = columnId;
      }
    },
    finishAddingTask(newTask) {

      this.bucket?.tasks.unshift(newTask);
      this.isAddingTask = false;
      this.selected_column_id = null;
    },
    cancelAddingTask() {
      this.isAddingTask = false;
      this.selected_column_id = null;
    },
    open_task_modal(task, bucket) {
      if (!task || !bucket) {
        console.warn("open_task_modal called with invalid task or bucket:", { task, bucket });
        return;
      }

      const latest_task =
        Array.isArray(bucket?.tasks)
          ? bucket?.tasks.find(t => t.id === task.id) || task
          : task;

      this.selected_task = latest_task;
      this.show_modal_assign_dropdown = false;
      this.modal_assign_search_query = '';

      this.task_id = latest_task.id || '';
      this.local_start_date = latest_task.start_date || '';
      this.local_due_date = latest_task.due_date || '';
      this.local_task_status_id = latest_task.progress?.id || '';
      this.local_priority_status_id = latest_task.priority?.id || '';
      this.selected_task_status_label_status = this.task_status_option_name('status', latest_task.progress);
      this.selected_task_status_label_priority = this.task_status_option_name('priority', latest_task.priority);
      this.description = latest_task.description || '';
      this.comments = Array.isArray(latest_task.comments) ? [...latest_task.comments] : [];

      if (this.task_id) {
        this.fetch_task_files(this.task_id);
      }

      const modal_id = `task_modal_${bucket.id}`;
      this.$nextTick(() => {
        const modal_el = document.getElementById(modal_id);
        if (!modal_el) return;

        const existing = bootstrap.Modal.getInstance(modal_el);
        if (existing) {
          existing.hide();
          existing.dispose();
        }

        const modal = new bootstrap.Modal(modal_el);
        modal.show();
      });
    },
    toggle_modal_assign_dropdown() {
      this.show_modal_assign_dropdown = !this.show_modal_assign_dropdown;
      if (this.show_modal_assign_dropdown) {
        this.modal_assign_search_query = '';
      }
    },
    close_modal_assign_dropdown() {
      this.show_modal_assign_dropdown = false;
      this.modal_assign_search_query = '';

      this.$nextTick(() => {
        this.$refs.modalAssignDropdown?.classList.remove('show');
      });
    },
    handle_modal_assign_click_outside(event) {
      if (!this.show_modal_assign_dropdown) return;
      const container = this.$refs.modalAssignContainer;
      if (container && !container.contains(event.target)) {
        this.close_modal_assign_dropdown();
      }
    },
    apply_updated_task_from_modal(updatedTask) {
      if (!updatedTask || !updatedTask.id) return;
      this.selected_task = updatedTask;

      const taskIndex = this.bucket?.tasks?.findIndex(t => t.id === updatedTask.id);
      if (taskIndex !== -1) {
        this.bucket.tasks.splice(taskIndex, 1, updatedTask);
      }
    },
    assign_user_from_modal(member_id) {
      this.close_modal_assign_dropdown();

      const baseUrl = `${window.location.origin}${this.$route.path}`;
      const encodedReportUrl = encodeURI(`${baseUrl}?task_id=${this.selected_task.id}`);

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/assign_users_to_task/`,
        method: "POST",
        data: JSON.stringify({
          task_id: this.selected_task.id,
          assigned_ids: [member_id],
          base_url: encodedReportUrl
        }),
        headers: {
          "Authorization": `Token ${this.getToken()}`,
          "Content-Type": "application/json"
        },
        success: (response) => {
          if (response.status === "success") {
            this.apply_updated_task_from_modal(response.data);
            this.close_modal_assign_dropdown();
          }
        },
        error: (xhr) => {
          console.error("Error assigning user to task:", xhr);
        },
        complete: () => {
          this.close_modal_assign_dropdown();
        }
      });
    },
    remove_assigned_user_from_modal(assignee) {
      if (!assignee?.id) return;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/unassign_user_to_task/`,
        method: "POST",
        data: JSON.stringify({ task_assignee_id: assignee.id }),
        headers: {
          "Authorization": `Token ${this.getToken()}`,
          "Content-Type": "application/json"
        },
        success: (response) => {
          if (response.status === "success") {
            this.apply_updated_task_from_modal(response.data);
          }
        },
        error: (xhr) => {
          console.error("Error unassigning user from task:", xhr);
        }
      });
    },
    getInitials(name) {
      if (!name || typeof name !== 'string') return '??'; // fallback
      const parts = name.trim().split(' ');
      return parts.map(p => p[0]).join('').toUpperCase().substring(0, 2);
    },
    update_task(field, value, event) {
      if (event) event.preventDefault();
      const isClearingTaskStatusRelation = (field === 'status' || field === 'priority') && !value;
      const payload = {
        task_id: this.task_id,
      };

      if (field === 'status') {
        payload.progress_id = value || null;
        if (!value) {
          payload.progress = null;
          payload.status_id = null;
          payload.task_status_id = null;
          payload.clear_progress = true;
        }
      }
      if (field === 'priority') {
        payload.priority_id = value || null;
        if (!value) {
          payload.priority = null;
          payload.clear_priority = true;
        }
      }
      if (field === 'start_date') payload.start_date = value || null;
      if (field === 'due_date') payload.due_date = value;
      if (field === 'description') payload.description = value;
      if (field === 'name') payload.task_name = value;

      // Call your API
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_task/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (isClearingTaskStatusRelation) {
            this.apply_task_status_clear(field);
            return;
          }

          const updatedTask = response.data || { ...this.selected_task };
          // Update local data so UI reflects changes immediately
          if (field === 'status') {
            this.local_task_status_id = value || '';
            this.selected_task.status_id = value || null;
            this.selected_task.progress = value ? updatedTask.progress : null;
          }
          if (field === 'priority') {
            this.local_priority_status_id = value || '';
            this.selected_task.priority_id = value || null;
            this.selected_task.priority = value ? updatedTask.priority : null;
          }
          if (field === 'start_date') {
            this.local_start_date = value;
            this.selected_task.start_date = value;
          }
          if (field === 'due_date') {
            this.local_due_date = value;
            this.selected_task.due_date = value;
          }
          if (field === 'description') {
            this.selected_task.description = value;
          }
          if (field === 'name') {
            this.selected_task.name = value;
          }

          const taskIndex = this.bucket?.tasks.findIndex(t => t.id === updatedTask.id);
          if (taskIndex !== -1) {
            // Use Vue.set if using Vue 2, or direct assignment in Vue 3
            this.bucket.tasks.splice(taskIndex, 1, updatedTask);
          }
        },
        error: (err) => {
          console.error("Error updating a task:", err);
        }
      });

    },
    clear_task_status(field) {
      this.set_selected_task_status_label(field, '');
      this.apply_task_status_clear(field);
      this.update_task(field, null);
    },
    apply_task_status_clear(field) {
      if (!this.selected_task?.id) return;

      if (field === 'status') {
        this.local_task_status_id = '';
        this.selected_task.status_id = null;
        this.selected_task.progress = null;
      }
      if (field === 'priority') {
        this.local_priority_status_id = '';
        this.selected_task.priority_id = null;
        this.selected_task.priority = null;
      }

      const taskIndex = this.bucket?.tasks?.findIndex((task) => Number(task.id) === Number(this.selected_task.id));
      if (Number.isInteger(taskIndex) && taskIndex !== -1) {
        const existingTask = Reflect.get(this.bucket.tasks, taskIndex);
        this.bucket.tasks.splice(taskIndex, 1, {
          ...existingTask,
          ...this.selected_task
        });
      }
    },
    task_status_options(field) {
      return field === 'priority' ? this.priorities : this.statuses;
    },
    task_status_placeholder(field) {
      if (field === 'priority') {
        return this.can_manage_task_statuses
          ? 'Select or add your own priority...'
          : 'Select priority...';
      }

      return this.can_manage_task_statuses
        ? 'Select or add your own progress...'
        : 'Select progress...';
    },
    task_status_search_value(field) {
      return field === 'priority' ? this.task_status_search_priority : this.task_status_search_status;
    },
    set_task_status_search_value(field, value) {
      if (field === 'priority') {
        this.task_status_search_priority = value;
        return;
      }
      this.task_status_search_status = value;
    },
    selected_task_status_label_value(field) {
      return field === 'priority' ? this.selected_task_status_label_priority : this.selected_task_status_label_status;
    },
    set_selected_task_status_label(field, value) {
      if (field === 'priority') {
        this.selected_task_status_label_priority = value;
        return;
      }
      this.selected_task_status_label_status = value;
    },
    task_status_option_name(field, option) {
      const name = field === 'priority'
        ? option?.priority_name || option?.priority_status || option?.name
        : option?.task_name || option?.task_status || option?.name;
      return String(name || '').trim();
    },
    filtered_task_status_options(field) {
      const query = String(this.task_status_search_value(field) || '').trim().toLowerCase();
      const options = this.task_status_options(field);
      if (!query) return options;

      return options.filter((option) => (
        this.task_status_option_name(field, option).toLowerCase().includes(query)
      ));
    },
    can_add_task_status(field) {
      if (!this.can_manage_task_statuses) return false;
      const query = String(this.task_status_search_value(field) || '').trim().toLowerCase();
      if (!query) return false;

      return !this.task_status_options(field).some((option) => (
        this.task_status_option_name(field, option).toLowerCase() === query
      ));
    },
    selected_task_status_label(field) {
      const selectedId = field === 'priority' ? this.local_priority_status_id : this.local_task_status_id;
      if (!selectedId) return '';

      const selected = this.task_status_options(field).find((option) => (
        Number(option.id) === Number(selectedId)
      ));
      const label = this.task_status_option_name(field, selected) || this.selected_task_status_label_value(field);
      return this.format_label(label);
    },
    open_task_status_dropdown(field) {
      this.set_task_status_search_value(field, '');
      this.$nextTick(() => {
        const input = field === 'priority' ? this.$refs.prioritySearchInput : this.$refs.progressSearchInput;
        input?.focus();
      });
    },
    close_task_status_dropdown(field) {
      const toggle = field === 'priority' ? this.$refs.priorityDropdownToggle : this.$refs.progressDropdownToggle;
      const dropdown = bootstrap.Dropdown.getInstance(toggle);
      dropdown?.hide();
    },
    select_task_status(field, value) {
      if (field === 'status') this.local_task_status_id = value;
      if (field === 'priority') this.local_priority_status_id = value;
      const selected = this.task_status_options(field).find((option) => (
        Number(option.id) === Number(value)
      ));
      this.set_selected_task_status_label(field, value ? this.task_status_option_name(field, selected) : '');
      if (!value) this.apply_task_status_clear(field);
      this.update_task(field, value);
      this.close_task_status_dropdown(field);
    },
    start_task_status_add(field) {
      if (!this.can_manage_task_statuses) return;
      this.close_task_status_dropdown(field);
      this.adding_task_status_field = field;
      this.new_task_status_name = String(this.task_status_search_value(field) || '').trim();
      this.task_status_add_error = '';
      this.save_task_status(field);
    },
    save_task_status(field) {
      if (!this.can_manage_task_statuses) return;
      const isPriority = field === 'priority';
      const label = isPriority ? 'priority' : 'progress';
      const name = String(this.new_task_status_name || '').trim();
      if (!name) {
        this.task_status_add_error = `Enter a ${label} name`;
        return;
      }
      if (this.creating_task_status) return;

      const endpoint = isPriority ? 'create_priority_status' : 'create_task_status';
      const payload = isPriority ? { priority_status: name } : { task_status: name };
      this.creating_task_status = true;
      this.task_status_add_error = '';

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/${endpoint}/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status !== 'success') {
            this.task_status_add_error = response.message || `Could not add ${label}. Please try again.`;
            return;
          }

          const createdStatus = response.data;
          this.$emit(isPriority ? 'priorities-updated' : 'statuses-updated');

          if (createdStatus?.id) {
            this.set_selected_task_status_label(field, this.task_status_option_name(field, createdStatus) || name);
            if (field === 'status') this.local_task_status_id = createdStatus.id;
            if (field === 'priority') this.local_priority_status_id = createdStatus.id;
            this.update_task(field, createdStatus.id);
          }
          this.adding_task_status_field = '';
          this.new_task_status_name = '';
          this.task_status_add_error = '';
        },
        error: (err) => {
          console.error(`Error creating task ${label}:`, err);
          this.task_status_add_error = `Could not add ${label}. Please try again.`;
        },
        complete: () => {
          this.creating_task_status = false;
        }
      });
    },
    add_comment() {
      if (!this.comment) return;

      const payload = {
        task_id: this.task_id,
        comment: this.comment
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/post_task_comment/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            this.comments.push(response.data);

            if (!this.selected_task.comments) {
              this.selected_task.comments = [];
            }

            this.selected_task.comments.push(response.data);
            this.comment = '';
            Swal.fire({
              icon: "success",
              title: "Comment Send",
              text: "Comment added successfully.",
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            });
          }
        },
        error: (err) => {
          console.error("Error adding comment:", err);
        }
      });
    },


    deleteColumn() {
      const column = this.bucket;

      // Check if the column has tasks
      const hasTasks = column.tasks && column.tasks.length > 0;

      // Build confirmation message
      const message = hasTasks
        ? `The column "${column.name}" contains ${column.tasks.length} task(s). Are you sure you want to delete it?`
        : `Are you sure you want to delete the column "${column.name}"?`;

      // Show SweetAlert2 confirmation
      Swal.fire({
        title: 'Confirm Delete',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, delete it',
        cancelButtonText: 'Cancel',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;

          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_column/`,
            method: 'DELETE',
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json',
            },
            data: JSON.stringify({ column_id: column.id }),
            success: () => {
              Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: `The column "${column.name}" has been deleted.`,
                timer: 2000,
                showConfirmButton: false,
                position: 'bottom-end',
                toast: true
              });

              // Notify parent to remove this column visually
              this.$emit('delete-bucket');
            },
            error: () => {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to delete the column. Please try again.',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            },
            complete: () => {
              this.isLoading = false;
            }
          });
        }
      });
    },

    async submit_checklist_item(item) {
      if (!item.text.trim()) return;

      try {
        if (item.id) {
          await this.update_checklist_item(item);
        } else {
          const newItem = await this.createChecklistItem(item.text);

          if (!this.selected_task.checklist_items) {
            this.selected_task.checklist_items = [];
          }
          this.selected_task.checklist_items.push(newItem);

          this.$nextTick(() => {
            const input =
              this.$refs['checklistInput-' + (this.selected_task.checklist_items.length - 1)];
            if (input && input.$el) input.$el.focus();
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    createChecklistItem(text) {
      return new Promise((resolve, reject) => {
        if (!text.trim()) return reject('Empty text');

        const payload = {
          task_id: this.task_id,
          text: text
        };

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_checklist_item/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(payload),
          success: (response) => {
            if (response.status === "success") {
              resolve(response.data);
            } else {
              reject(response.message || 'Error creating checklist item');
            }
          },
          error: (err) => reject(err)
        });
      });
    },


    update_checklist_item(item) {
      return new Promise((resolve, reject) => {
        const payload = {
          item_id: item.id,
          text: item.text,
          is_completed: item.is_completed
        };

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_checklist_item/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(payload),
          success: (response) => {
            if (response.status === "success") resolve(response.data);
            else reject(response.message);
          },
          error: (err) => reject(err)
        });
      });
    },
    delete_check_list_item(item) {
      if (!item.id) return; // placeholder, nothing to delete

      const payload = { item_id: item.id };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_checklist_item/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: () => {
          const index = this.selected_task.checklist_items.findIndex(i => i.id === item.id);
          if (index !== -1) this.selected_task.checklist_items.splice(index, 1);
        },
        error: err => console.error(err)
      });
    },

    delete_task_attachment(file_id) {
      Swal
        .fire({
          title: "Are you sure?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          position: 'bottom-end',
          toast: true
        })
        .then((result) => {
          if (result.isConfirmed) {
            const payload = {
              file_id: file_id,
              task_id: this.selected_task.id,
            };

            $.ajax({
              url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_task_attachment/`,
              method: "DELETE",
              headers: {
                Authorization: `Token ${this.getToken()}`,
                "Content-Type": "application/json",
              },
              data: JSON.stringify(payload),
              success: () => {
                // Remove from task_attachments list immediately
                const index = this.task_attachments.findIndex(
                  (f) => f.id === file_id || (f.is_temp && f.id === file_id)
                );
                if (index !== -1) {
                  this.task_attachments.splice(index, 1);
                }
              },
              error: (err) => {
                console.error(err);
              },
            });
          }
        });
    },

    updateTaskPosition(taskId, columnId, position) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/reorder_task/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          task_id: taskId,
          column_id: columnId,
          position: position
        }),
        success: () => {
          // Update local task position immediately
          const task = this.tasks.find(t => t.id === taskId);
          if (task) {
            task.position = position;
          }
        },
        error: (err) => {
          console.error("Error updating task position:", err);
        }
      });
    },

    remove_task(taskId) {
      this.bucket.tasks = this.bucket.tasks.filter(task => task.id !== taskId);
    },
    handleTaskUpdated(updatedTask) {
      const index = this.bucket.tasks.findIndex(t => t.id === updatedTask.id);
      if (index !== -1) {
        this.bucket.tasks.splice(index, 1, updatedTask); // ✅ this triggers reactivity
      }
    },
    handle_file_change(event) {
      const file = event.target.files[0];
      if (!file) return;

      const file_name = file.name;

      // 1️⃣ Temporary preview object
      const tempId = Date.now();
      const tempFile = {
        id: tempId,
        file_name: file_name,
        s3_url: URL.createObjectURL(file),
        is_temp: true
      };

      // Show immediately in UI
      this.task_attachments.unshift(tempFile);

      // 2️⃣ Prepare FormData for backend
      const formData = new FormData();
      formData.append("file", file);
      formData.append("task_id", this.task_id);
      formData.append("file_name", file_name);
      formData.append("portal_id", this.$route.params.portal_id);
      formData.append("column_id", this.bucket.id);
      formData.append("board_id", this.$route.params.board_id);
      formData.append("portal_name", this.$route.params.portal_name);
      formData.append("task_name", this.selected_task.name);
      formData.append("board_name", this.$route.params.board_name);

      // 3️⃣ Upload to backend
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_task_attachment/`,
        method: "POST",
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === "success") {
            const backendFile = response.file;

            const attachment = this.task_attachments.find(f => f.id === tempId);
            if (attachment) {
              // Keep tempId for Vue key, store backend id separately
              attachment.id = backendFile.id;
              attachment.backend_id = backendFile.id || null;
              attachment.backend_url = backendFile.s3_url || '';
              attachment.is_temp = false;
            }
          }
        },

        error: (err) => {
          // Remove temp preview if request fails
          const index = this.task_attachments.findIndex(f => f.id === tempId);
          if (index !== -1) this.task_attachments.splice(index, 1);
          console.error("Upload error:", err);
        }
      });
    },
    fetch_task_files(task_id) {
      this.task_attachments = []; // Reset before fetching new files
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_task_attachments/`,
        method: 'POST',
        data: JSON.stringify({ task_id: task_id }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.task_attachments = response.attachments;
          }

        },

        complete: () => {
          this.isLoading = false;
        }
      });

    },
    isImage(fileName) {
      return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileName);
    },
    get_task_attachment_url(file) {
      return (
        file?.backend_url ||
        file?.s3_url ||
        file?.file_url ||
        file?.url ||
        ""
      );
    },
    get_task_attachment_name(file) {
      if (file?.file_name) return file.file_name;

      const file_url = this.get_task_attachment_url(file);
      if (!file_url) return "attachment";

      try {
        const parsed_url = new URL(file_url);
        return decodeURIComponent(parsed_url.pathname.split("/").pop() || "attachment");
      } catch {
        const url_without_query = String(file_url).split("?")[0];
        const path_parts = url_without_query.split("/");
        return decodeURIComponent(path_parts[path_parts.length - 1] || "attachment");
      }
    },
    downloadFile(file) {
      const file_url = this.get_task_attachment_url(file);
      if (!file_url) {
        Swal.fire({
          icon: "error",
          title: "Download unavailable",
          text: "This attachment does not have a valid file URL yet.",
          position: "bottom-end",
          toast: true,
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }

      const link = document.createElement("a");
      link.href = file_url;
      link.download = this.get_task_attachment_name(file);
      link.target = "_blank";
      link.rel = "noopener";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async on_drag_change(evt) {
      if (!evt) return;

      // --- Moving between columns ---
      if (evt.added && evt.added.element) {
        const task = evt.added.element;
        const bucketName = this.bucket.name;
        const toColumnId = this.bucket.id;
        const fromColumnId = task.column?.id || task.column || task.column_id;

        // Map bucket to deployment target_env
        const bucketToEnvMap = {
          'Staging Ready': 'Development',
          'Staged': 'Staging',
          'UAT Ready': 'UAT',
          'UAT': 'UAT',
          'Completed': 'Master'
        };
        const targetEnv = Reflect.get(bucketToEnvMap, bucketName);


        // Update column locally
        task.column_id = toColumnId;

        // Update positions after DOM update
        nextTick(() => {
          this.bucket.tasks.forEach((t, i) => t.position = i + 1);
        });

        // Move task on backend
        try {
          const fromBucket = this.buckets.find(bucket => Number(bucket.id) === Number(fromColumnId));
          if (fromBucket && Number(fromBucket.id) !== Number(toColumnId)) {
            fromBucket.tasks = (fromBucket.tasks || []).filter(
              sourceTask => Number(sourceTask.id) !== Number(task.id)
            );
          }

          await this.moveTaskToColumn(task.id, toColumnId);
          if (fromBucket && Number(fromBucket.id) !== Number(toColumnId)) {
            await this.reload_column_tasks(fromBucket);
          }
        } catch (moveErr) {
          console.error("Failed to move task:", moveErr);
        }

        // Create deployment ticket if bucket maps to a target_env
        if (targetEnv) {
          try {
            await axios.post(
              `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_deployment_ticket/`,
              {
                task_id: task.id,
                target_env: targetEnv
              },
              {
                headers: { Authorization: `Token ${this.getToken()}` }
              }
            );

          } catch (err) {
            console.error("Failed to create deployment ticket:", err);
          }
        }
      }

      // --- Reordering within same column ---
      if (evt.moved && evt.moved.element) {
        const task = evt.moved.element;
        const newPosition = evt.moved.newIndex + 1; // assuming position starts at 1

        // Update task locally
        task.position = newPosition;

        // Call backend once
        this.updateTaskPosition(task.id, this.bucket.id, newPosition);

        // Optional: re-sort local tasks by position to be safe
        this.bucket.tasks.sort((a, b) => a.position - b.position);
      }
    },


    async moveTaskToColumn(task_id, column_id) {
      const response = await axios.post(
        `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/move_task_to_bucket/`,
        { task_id, column_id },
        {
          headers: ({
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          })
        }
      ).finally(() => {
        this.isLoading = false;
      });

      if (response.data?.status === 'success') {
        const updatedTask = response.data.data;
        if (updatedTask?.id) {
          const taskIndex = this.bucket.tasks.findIndex(task => task.id === updatedTask.id);
          if (taskIndex !== -1) {
            this.bucket.tasks.splice(taskIndex, 1, updatedTask);
          }
        }
      }

      return response;
    },
    toggleItem(item) {
      if (!item.id) return;

      if (item.is_completed) {
        this.complete_checklist_item_api(item.id);
      }
    },

    async complete_checklist_item_api(itemId) {

      const headersConfig = {
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
      };
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/complete_checklist_item/`,
          { item_id: itemId },
          headersConfig
        );

        const updated = response.data;
        const index = this.checklist_with_placeholder.findIndex(i => i.id === updated.id);
        if (index !== -1) {
          this.$set(this.checklist_with_placeholder, index, updated);
        }
      } catch (error) {
        console.error("Failed to complete checklist item:", error);

        const item = this.checklist_with_placeholder.find(i => i.id === itemId);
        if (item) item.is_completed = false;
      }
    },
    async delete_comment(commentId) {
      if (!commentId) return;

      this.loading = true;

      // Ensure number type
      const idToDelete = Number(commentId);

      const headersConfig = {
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
      };

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_task_comment/`,
          { comment_id: idToDelete },
          headersConfig
        );

        if (response.data.status === "success") {
          this.comments = this.comments.filter(c => Number(c.id) !== idToDelete);
        }
      } catch (error) {
        console.error("Error deleting comment:", error);
      } finally {
        this.loading = false;
      }
    },
    formatTimestamp(isoTimestamp, shortFormat = false) {
      const date = new Date(isoTimestamp);

      const options = shortFormat
        ? {
          month: 'short', // Nov
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        }
        : {
          year: 'numeric',
          month: 'long', // November
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        };

      return date.toLocaleString('en-US', options);
    },
    autoResize() {
      const task_input_event = this.$refs.taskInput;
      if (!task_input_event) return;
      task_input_event.style.height = 'auto';
      task_input_event.style.height = task_input_event.scrollHeight + 'px';
    }

  }
};

